import React from 'react';
import {
    Button
} from 'react-bootstrap';
import Swal from 'sweetalert2';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Axios from 'axios';
import Configs from '../../../Configs';
import Parse from '../../../Parse';

class MoreFoodPandaConfigurationsButton extends React.PureComponent {

    state = {
        openPopup: false,
        loading: false,
        params: {},
        isEmpty: false
    };

    componentDidMount() {
       this.getControllerStatus()
    }

    getControllerStatus = () => {
        const object = this.props.object;
        this.setState({
            loading: true
        })
        if(object == undefined) {
            this.setState({
                isEmpty: true
            })
            return;
        }
        if(object.owner == undefined) {
            this.setState({
                isEmpty: true
            })
            return;
        }
        const ownerId = object.owner ? object.owner : "";
        const controller = object.controller;
        Axios.post(`${Configs.serverUrl}/api/member/${ownerId}/controller/${controller}/status`).then(res => {
            const data = res.data;
            this.setState({
                loading: false,
                isEmpty: false,
                params: {
                    ...data
                }
            })
        }).catch(res => {
            this.setState({
                loading: false,
                isEmpty: true
            })
        })
    }

    updateServerConfig = () => {
        const params = {...this.state.params};
        this.setState({
            loading: true
        })
        Parse.Cloud.run("updateServerConfig", {
            ...params
        })
        .then((res) => {
            this.setState({
                loading: false
            }, () => {
                Swal.fire(`Update information Successful`);
                this.props.history.push(`/object/${this.props.classes}`);
            })
        })
        .catch((err) => {
            this.setState({
                loading: false
            })
            Swal.fire(`Error when Update information`);
        })
    }

    closePopupHandler = () => {
        this.setState({
            openPopup: false,
        })
    }

    openPopupHandler = () => {
        this.setState({
            openPopup: true,
        })
    }

    inputChangeHandler = (val, key, value) => {
        const params = {...this.state.params};
        this.setState({
            params: {
                ...params,
                [key]: {
                    ...params[key],
                    [value]: val
                }
            }
        })
    }

    render () {
        const params = {...this.state.params};
        return (
            <React.Fragment>
                <Button variant="success pull-right" onClick={() => this.openPopupHandler()}>
                    <i className="fa fa-cog"></i>
                    <span className="hidden-xs hidden-sm">&nbsp;Server Config</span>
                </Button>
                {
                    this.state.openPopup ? (
                        <div className="MoreButtonPopup">
                            <div className="popup_image_bover">
                            </div>
                            <div className="popup_image form-popup">
                                <div className="form-container">
                                    <div className="popup_header">
                                        <h3 className="pull-left">FoodPand Configurations</h3>
                                    </div>
                                    <div className="popup_body">
                                        {
                                            this.state.loading ? (
                                                <Spinner></Spinner>
                                            ) : (
                                                <div className="col-md-12 col-xs-12 col-lg-12">
                                                    <div className={`form-group ${ params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id ? `has-error` : ""}`}>
                                                        <label>userPlanDevice -> option1 -> plan_foodpanda_token</label>
                                                        <input type="text" className="form-control" value={params.userPlanDevice !== undefined && params.userPlanDevice.plan_foodpanda_token !== undefined && params.userPlanDevice.plan_foodpanda_token ? params.userPlanDevice.plan_foodpanda_token : ""} onChange={(e) => {
                                                            this.inputChangeHandler(e.target.value, "userPlanDevice", "plan_foodpanda_token");
                                                        }} disabled={params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id} />
                                                        {
                                                            params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id ? (
                                                                <span className="help-block">{`No record User Plan Device`}</span>
                                                            ) : null
                                                        }
                                                    </div>
                                                    <div className={`form-group ${ params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id ? `has-error` : ""}`}>
                                                        <label>userPlanDevice -> option1 -> plan_foodpanda_merchant</label>
                                                        <input type="text" className="form-control" value={params.userPlanDevice !== undefined && params.userPlanDevice.plan_foodpanda_merchant !== undefined && params.userPlanDevice.plan_foodpanda_merchant ? params.userPlanDevice.plan_foodpanda_merchant : ""} onChange={(e) => {
                                                            this.inputChangeHandler(e.target.value, "userPlanDevice", "plan_foodpanda_merchant");
                                                        }} disabled={params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id} />
                                                        {
                                                            params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id ? (
                                                                <span className="help-block">{`No record User Plan Device`}</span>
                                                            ) : null
                                                        }
                                                    </div>
                                                    <div className={`form-group ${ params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id ? `has-error` : ""}`}>
                                                        <label>userPlanDevice -> option1 -> plan_foodpanda_chaincode</label>
                                                        <input type="text" className="form-control" value={params.userPlanDevice !== undefined && params.userPlanDevice.plan_foodpanda_chaincode !== undefined && params.userPlanDevice.plan_foodpanda_chaincode ? params.userPlanDevice.plan_foodpanda_chaincode : ""} onChange={(e) => {
                                                            this.inputChangeHandler(e.target.value, "userPlanDevice", "plan_foodpanda_chaincode");
                                                        }} disabled={params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id} />
                                                        {
                                                            params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id ? (
                                                                <span className="help-block">{`No record User Plan Device`}</span>
                                                            ) : null
                                                        }
                                                    </div>
                                                    <div className={`form-group ${ params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id ? `has-error` : ""}`}>
                                                        <label>userPlanDevice -> option1 -> plan_foodpanda_chainvendorid</label>
                                                        <input type="text" className="form-control" value={params.userPlanDevice !== undefined && params.userPlanDevice.plan_foodpanda_chainvendorid !== undefined && params.userPlanDevice.plan_foodpanda_chainvendorid ? params.userPlanDevice.plan_foodpanda_chainvendorid : ""} onChange={(e) => {
                                                            this.inputChangeHandler(e.target.value, "userPlanDevice", "plan_foodpanda_chainvendorid");
                                                        }} disabled={params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id} />
                                                        {
                                                            params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id ? (
                                                                <span className="help-block">{`No record User Plan Device`}</span>
                                                            ) : null
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="popup_footer">
                                        <div className="row">
                                            <div className="col-xs-4 col-md-4 col-lg-4 buttonFooter">
                                                <button className="btn btn-primary btn-block" onClick={this.updateServerConfig}>Save</button>
                                            </div>
                                            <div className="col-xs-4 col-md-4 col-lg-4 buttonFooter">
                                                <button className="btn btn-default btn-block" onClick={this.getControllerStatus}>Refresh</button>
                                            </div>
                                            <div className="col-xs-4 col-md-4 col-lg-4 buttonFooter">
                                                <button className="btn btn-default btn-block" onClick={this.closePopupHandler}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null
                }
            </React.Fragment>
        )
    }
}

export default MoreFoodPandaConfigurationsButton;